<template>
  <v-app>
    <v-fade-transition>
      <div class="splash-screen" v-if="splashScreen">
        <img src="./assets/logo.png" class="logo" alt="logo" />
        <!-- <img src="/Ripple-2s-200px.gif" alt="loading-image"> -->
      </div>
    </v-fade-transition>
    <StartBreak v-if="isBreakActive" />

    <router-view />

    <!-- NOTIFICACIONES -->
    <vue-snotify></vue-snotify>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.text }}
    </v-snackbar>

    <!-- <v-speed-dial
      fixed
      right
      bottom
      v-model="fab"
      direction="top"
      transition="slide-y-reverse-transition"
      style="z-index: 2000"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>

      <v-btn fab dark small color="indigo">
        <v-icon>mdi-video</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="activeFloatingChat">
        <v-icon>mdi-chat</v-icon>
      </v-btn>
    </v-speed-dial> -->

    <!-- <floating-chat :isActive="FloatingChat" @dialog:close="closeFloatingChat" /> -->
  </v-app>
</template>

<script>
// import FloatingChat from "@/components/core/FloatingChat.vue";
import StartBreak from "@/components/Utils/StartBreak";
import { getChatBody } from "@/utils/chatHelpers";
/**
 * This was used with the websocket method
 */
// import Echo from "laravel-echo";
// window.Pusher = require("pusher-js");

export default {
  name: "App",
  mounted() {
  /**
     * This was used with the websocket method
     */
    // window.Echo = new Echo({
    //   broadcaster: "pusher",
    //   key: "POTR2525",
    //   wsHost: "d1.2cs.co",
    //   wsPort: 6001,
    //   wssPort: 6001,
    //   disableStats: true,
    //   forceTLS: false,
    // });

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("firebase-messaging-sw.js").catch((error) => {
        const msg = `Service Worker Error (${error})`;
        console.error(msg);
      });
    } else {
      // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
      console.warn("Service Worker not available");
    }

    this.$messaging.onMessage((res) => {
      // console.log("Mensaje recibido en primer plano: ", res);
      const body = getChatBody(res);
      // console.log("PARSED ", getChatBody(res));
      const tab = body.ticket?.userId === null ? "pending" : "active";
      const chatId = body.ticket?.id;
      const message = body.ticket?.userId === null ? "Nuevo chat en cola" : "Nuevo mensaje de chat.";
      const notif = this.$snotify.info(message, "Chats");
      this.playNotifSound();
      notif.on("click", () => {
        this.$router.push({ path: "/chats", query: { tab, chatId } });
      });
      this.$store.dispatch("triggerRefreshChats");
    });
  },
  components: {
    StartBreak,
    // FloatingChat,
  },
  data: () => ({
    fab: false,
    // FloatingChat: false,
  }),

  computed: {
    splashScreen() {
      return this.$store.getters.splashScreen;
    },

    isBreakActive() {
      return this.$store.getters["breaks/GET_IS_BREACK_ACTIVE"];
    },

    snackbar() {
      return this.$store.getters["layout/GET_SNACKBAR"];
    },
  },
  methods: {
    playNotifSound() {
      const audio = new Audio("/sounds/foreground-notification.mp3");

      audio.play().catch((error) => {
        console.warn("El auto-play fue bloqueado o el archivo no se encontró:", error);
      });
    },
  },
  // methods: {
  //   activeFloatingChat(item) {
  //     this.FloatingChat = true;
  //     // this.fab = false;
  //   },

  //   closeFloatingChat(value) {
  //     this.FloatingChat = false;
  //   },
  // },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;800&display=swap");
@import "./assets/styles/index.scss";

#app {
  font-family: "Poppins", sans-serif !important;
  word-break: normal !important;
  line-height: normal !important;
}

.theme--light.v-application {
  background: #eff0f8 !important;
  // background: #e8e7e7 !important;
  color: #495057 !important;
}

.grecaptcha-badge {
  display: none !important;
}
</style>
